module.exports = __webpack_public_path__ + "0c2a991d3c8503e48325b59f862428ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/settings/wechat.png
// module id = 314
// module chunks = 0